<div class="header">
    <div class="app-sidebar sidebar-shadow">
        <div class="app-sidebar-content">
            <div class="app-sidebar-scroll">
                <div class="logo-container">
                    <div class="logo-section">
                        <ng-container>
                            <img src="/assets/images/Roomease.jpg" class="DarAtlassLogo logo-image">
                        </ng-container>
                    </div>
                </div>


                <div *ngIf="loading" class="flex justify-center items-center h-screen">
                    <div class="loader border-t-4 border-blue-500 rounded-full w-16 h-16 animate-spin"></div>
                </div>

                <div *ngIf="!loading" class="container">
                    <ul>
                        <ng-container *ngFor="let menu of rootMenus">
                            <dynamic-sidebar-item [menu]="menu"></dynamic-sidebar-item>
                        </ng-container>
                    </ul>
                </div>
                <div>
                    <button type="button" class="btn btn-light" (click)="sendToSupport()" style="margin-left:30%">Support</button>
                </div>
            </div>
        </div>
    </div>
</div>
